<template>

  <div v-show="(!isPopout && !isMinimize) || isSwayChatPopout" class="swaychat-chatbox-container"
    :style="{
      maxHeight: maxHeight + 'px'
      }"
    :class="{
      'swaychat-minimize-window' : isMinimize && !isSwayChatPopout,
      'swaychat-maximize-window': isSwayChatPopout,
      'swaychat-contrast-dark' : isLightDark == 'dark',
      'swaychat-contrast-light' : isLightDark == 'light',
      'swaychat-zoomIn' : !isSwayChatPopout
    }
    ">
      <slot></slot>
  </div>

</template>

<script>


import { mapGetters } from 'vuex'

export default {
  created() {
    window.addEventListener('resize', this.setMaxHeight)
    this.setMaxHeight()

  },
  computed: {
      isPopout() {
        if (this.isSwayChatPopout)
          return false
        return this.$store.getters.isPopout
      },
      ...mapGetters([
        'getStartUpMode',
        'isMinimize',
        'getPrimaryBg',
        'isLightDark',
        'isSwayChatPopout'
      ])
  },
  data() {
    return {
      maxHeight: 0
    }
  },
  methods: {
    setMaxHeight() {
      this.maxHeight = document.documentElement.clientHeight
      if (!window.isSwayChatPopout) this.maxHeight -= 64
    }
  }

}

</script>
